/**
 * [CLAIMS_CONTEXT]
 * purpose: Reuse veranda-like panel material and glazing choices for swimming pool cover declaration and summaries.
 * touches: declaration, backoffice edition
 * invariants: swimming pool cover panels use the same material/glazing value set as veranda panels
 * inputs: panel material and glazing values
 * outputs: translated image/radio choices for the swimming pool cover flow
 * see: frontend/src/shared/constants/externalDamages/VerandaConstants.ts, frontend/src/shared/types/api/externalDamage.ts
 */
export { VERANDA_PANELS_MATERIAL_TRAD_KEYS_AND_IMAGES as SWIMPOOL_COVER_PANELS_MATERIAL_TRAD_KEYS_AND_IMAGES, VERANDA_PANELS_MATERIAL_CHOICES as SWIMPOOL_COVER_PANELS_MATERIAL_CHOICES, VERANDA_GLASS_PANEL_GLAZING_TRAD_KEYS_AND_IMAGES as SWIMPOOL_COVER_GLASS_PANEL_GLAZING_TRAD_KEYS_AND_IMAGES, VERANDA_GLASS_PANEL_GLAZING_CHOICES as SWIMPOOL_COVER_GLASS_PANEL_GLAZING_CHOICES, } from './VerandaConstants';
